const BLOG_CONTAINER_ID = 'pagination-container';

const blogFilters = () => ({
  filterLoading: false,
  filterByTag(ev) {
    const link = ev.currentTarget;
    if (!link || !link.href) return;
    const href = link.href;
    const container = document.getElementById(BLOG_CONTAINER_ID);
    if (!container) return;

    this.filterLoading = true;
    fetch(href)
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContainer = doc.getElementById(BLOG_CONTAINER_ID);
        if (!newContainer) return;

        const newTotal = parseInt(newContainer.dataset.totalItems, 10) || 0;
        const newGrid = doc.getElementById('blog-grid');
        const newPagination = doc.getElementById('blog-pagination');

        let newInner = '';
        if (newGrid) newInner += newGrid.outerHTML;
        if (newPagination) newInner += newPagination.outerHTML;
        container.innerHTML = newInner;

        const alpineData = window.Alpine && Alpine.$data(container);
        if (alpineData) {
          alpineData.items = newTotal;
          alpineData.showingResultCount = container.querySelectorAll('.article-card').length;
          bindLoadMoreButton(container, alpineData);
        }

        setFilterLinkActiveState(href);
        history.pushState({}, '', href);
      }) 
      .catch((err) => console.error('Blog filter error:', err))
      .finally(() => {
        this.filterLoading = false;
      });
  }
});

function bindLoadMoreButton(container, alpineData) {
  const button = container.querySelector('#load-more-button');
  if (!button || !alpineData.loadMore) return;
  button.addEventListener('click', (ev) => {
    ev.preventDefault();
    const nextUrl = button.getAttribute('href');
    if (nextUrl) alpineData.loadMore(nextUrl);
  });
}

function setFilterLinkActiveState(href) {
  const pathname = (typeof href === 'string' && href.startsWith('http')
    ? new URL(href).pathname
    : href || ''
  ).replace(/\/$/, '') || '/';
  document.querySelectorAll('.blog__filter-link').forEach((link) => {
    const linkPath = new URL(link.href, window.location.origin).pathname.replace(/\/$/, '');
    const isActive = linkPath === pathname;
    link.classList.toggle('blog__filter-link--active', isActive);
    link.classList.toggle('blog__filter-link--inactive', !isActive);
  });
}

const blogPagination = (limit, items) => ({
    loading: false,
    showingResultCount: limit,
    items: items,
    init() {},
    calculateProgressBarWidth(count) {
      return (+count * 100) / parseInt(this.items) + '%';
    },
    loadMore(NextUrl) {
      this.loading = true;
      fetch(NextUrl)
        .then(response => response.text())
        .then(data => {
          let html_div = document.createElement('div');
          html_div.innerHTML = data;
  
          const button = document.querySelector('#load-more-button');

          const href = button.getAttribute('href');
          
          const url = new URL(href, window.location.origin);
          const pageValue = url.searchParams.get('page');
          

          if (pageValue && parseInt(pageValue) === parseInt(button.getAttribute('data-total-pages'))) {
            document.querySelector('#blog-pagination').style.display = 'none';
          }
  
          let html_dom = html_div.querySelector('#blog-grid').innerHTML;
  
          if (document.querySelector('#blog-grid')) {
            document.querySelector('#blog-grid').innerHTML += html_dom;
          }
  
          this.showingResultCount = document.querySelectorAll('.article-card').length;
  
          this.calculateProgressBarWidth(this.showingResultCount);
  
          if (html_div.querySelector('#blog-pagination')) {
            let pagination_dom = html_div.querySelector('#blog-pagination').innerHTML;
            if (document.querySelector('#blog-pagination')) {
              document.querySelector('#blog-pagination').innerHTML = pagination_dom;
            }
          }

        })
        .catch(error => console.error('Error:', error))
        .finally(() => {
          this.loading = false;
        });
    }
});
  
  export default blogPagination;
  export { blogFilters };
  